import React from 'react';
import './style.css';
import { Col } from "reactstrap";

const LoginRegister = (props) => {
    return (
        <div className="w-100 d-flex align-items-center justify-content-center">
            <Col lg="3" md="5" className="main text-right">
                {props.children}
            </Col>
            <div className="w-100 h-100 position-absolute blurdiv"></div>
        </div>
    );
};

export { LoginRegister };